import React from "react";
import styled from "styled-components";

const MoleculeSizeArea = ({ title = "내 디스플레이", width = "1920", height = "1080" }) => {
  return (
    <StyledContainer>
      <StyledTitle>{title}</StyledTitle>
      <StyledSizeGroup>
        <StyledSizeBox>
          <StyledSizeNumber>{width}</StyledSizeNumber>
        </StyledSizeBox>
        <StyledMultiplySymbol>x</StyledMultiplySymbol>
        <StyledSizeBox>
          <StyledSizeNumber>{height}</StyledSizeNumber>
        </StyledSizeBox>
        <StyledUnit>px</StyledUnit>
      </StyledSizeGroup>
    </StyledContainer>
  );
};

export default MoleculeSizeArea;

// Styled Components
const StyledContainer = styled.div`
  width: 100%;
  padding: 12px 0;
  background: #ECF2FE;
  border-top: 1px solid #9EBDFA;
  border-bottom: 1px solid #9EBDFA;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

const StyledTitle = styled.span`
  color: black;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  line-height: 24px;
  word-wrap: break-word;
`;

const StyledSizeGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 7px;
`;

const StyledSizeBox = styled.div`
  padding: 0 8px;
  background: white;
  border-radius: 4px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
`;

const StyledSizeNumber = styled.span`
  color: black;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
`;

const StyledMultiplySymbol = styled.span`
  color: black;
  font-size: 14px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  line-height: 21px;
  word-wrap: break-word;
`;

const StyledUnit = styled.span`
  color: black;
  font-size: 14px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  line-height: 21px;
  word-wrap: break-word;
`; 